<template>
  <div class="self-loading">
    <div class="wrap">
      <img width="24" height="24" src="./loading.gif">
      <p class="desc">{{title}}</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    props: {
      title: {
        type: String,
        default: '正在载入...'
      }
    }
  }
</script>
<style lang="less" scoped>

  .self-loading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    text-align: center; 
    overflow: hidden;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    .wrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%)
    }
    .desc {
      line-height: 20px;
      font-size: 14px;
      color: #409eff;
    }
  }
</style>
